import styled from '@emotion/styled';
import { breakpointToContentSlotPadding } from 'ds/components/Layout';
import { BreakpointValue } from 'consts/breakpoints';


export const CarouselItem = styled.div`
  ${({ theme }) => `
    margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(2)};
    padding: ${theme.spacing(1)} ${theme.spacing(0.5)};
  `}
`;

export const WithCarouselShadow = styled.div<{ hasNextShadow?: boolean }>`
  ${({ theme, hasNextShadow }) => `
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 33px;
      pointer-events: none;
      z-index: 1;
      background: linear-gradient(to ${theme.isRTL ? 'right' : 'left'}, ${theme.colors.neutrals.grey9}, ${theme.colors.neutrals.transparent});
      ${theme.isRTL ? 'left' : 'right'}: 0;
      visibility: ${hasNextShadow ? 'visible' : 'none'};
    }
  `}
`;

export const LocalWinnersSection = styled.div`
  ${({ theme }) => {
    return Object
      .keys(breakpointToContentSlotPadding)
      .map(key => {
        const padding = breakpointToContentSlotPadding[key];
        return theme.media.showAt({ at: +key as BreakpointValue })`
          margin-left: -${theme.spacing(padding)};
          margin-right: -${theme.spacing(padding)};
          > div {
            padding-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(padding)};
          }
        `;
      });
  }}
`;
